
import React, { useState } from 'react';
import Button from 'view/common/elements/button';
import { InputText } from 'view/common/elements/input';

const Search = (props) => {
  const [term, setTerm] = useState("")
  return ( 
      <div className='flex w-full justify-between'>
          <InputText
            value={term}
            onChange={(v) => setTerm(v)}
            placeholder={"Search past uploads"}
            className="w-2/3"
            id="searchTerm"
          />
          
          <Button
            onClick={()=>console.log("Search "+term)}
            text={"Search"}
          />

      </div>
    ) 
}

export default Search;